import { jsx as _jsx } from "react/jsx-runtime";
import DashboardIcon from '@mui/icons-material/Dashboard';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import HubIcon from '@mui/icons-material/Hub';
import SettingsIcon from '@mui/icons-material/Settings';
import UndoIcon from '@mui/icons-material/Undo';
export const DHA_NAV_ITEMS = [
    {
        id: 'dha-dashboard',
        label: 'Dashboard',
        icon: _jsx(DashboardIcon, {}),
        path: '/tools/data-hydration-admin/dashboard',
        order: 0
    },
    {
        id: 'dha-batches',
        label: 'Batches',
        icon: _jsx(FolderCopyIcon, {}),
        path: '/tools/data-hydration-admin/batches',
        order: 1
    },
    {
        id: 'dha-hydrated-hubs',
        label: 'All Hubs',
        icon: _jsx(HubIcon, {}),
        path: '/tools/data-hydration-admin/hydrated-hubs',
        order: 2
    },
    {
        id: 'dha-rollback',
        label: 'Rollback',
        icon: _jsx(UndoIcon, {}),
        path: '/tools/data-hydration-admin/rollback',
        order: 3
    },
    {
        id: 'dha-validation',
        label: 'Validation',
        icon: _jsx(FactCheckIcon, {}),
        path: '/tools/data-hydration-admin/validation',
        order: 4
    },
    {
        id: 'dha-settings',
        label: 'Settings',
        icon: _jsx(SettingsIcon, {}),
        path: '/tools/data-hydration-admin/settings',
        order: 6
    }
];
